'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chicken = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Chicken, _Component);

  function Chicken() {
    (0, _classCallCheck3.default)(this, Chicken);
    return (0, _possibleConstructorReturn3.default)(this, (Chicken.__proto__ || (0, _getPrototypeOf2.default)(Chicken)).apply(this, arguments));
  }

  (0, _createClass3.default)(Chicken, [{
    key: 'render',
    value: function render() {
      var styles = require('./Recipes.scss');
      var chickenImg = require('./Assets/chicken.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.recipePanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Cheesy Chicken Meatballs'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.Row,
            null,
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Makes 25 balls.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Adding vegetables to mince, such as meatballs. Bolognese sauce, lasagne and burger rissoles is a common way to add in extra vegies without changing the meals kids enjoy very much (and tasting just as good)! Get kids involved when rolling balls by hand!'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 8 },
              _react2.default.createElement(
                'p',
                null,
                'Ingredients:'
              ),
              _react2.default.createElement(
                'ul',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '500 grams chicken mince'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 grated carrot'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 grated zucchini'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 small diced onion'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 clove of garlic, crushed'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '2 eggs'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '1 cup wholemeal bread crumbs [blitz 4 slices of wholemeal bread in a blender to make your own]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    '2 tablespoons olive oil [for frying]'
                  )
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  _react2.default.createElement(
                    'span',
                    null,
                    'Sweet chilli sauce, hummus or salsa for dipping'
                  )
                )
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(ReactBootstrap.Image, { src: chickenImg, responsive: true })
            ),
            _react2.default.createElement(ReactBootstrap.Col, { md: 1 }),
            _react2.default.createElement(
              ReactBootstrap.Col,
              { md: 12 },
              _react2.default.createElement(
                'p',
                null,
                'Instructions:'
              ),
              _react2.default.createElement(
                'ol',
                null,
                _react2.default.createElement(
                  'li',
                  null,
                  'Preheat oven to 180 degrees Celsius fan forced and line a baking tray with baking paper.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Add mince, vegetables, egg and breadcrumbs into a large bowl. Mix well.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Form evenly sized balls using your hands.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Heat olive oil in a large frypan until just sizzling and add meatballs. Turn meatballs to brown for a few minutes and place on the prepared baking tray.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Bake for an additional 10 minutes or until cooked through completely.'
                ),
                _react2.default.createElement(
                  'li',
                  null,
                  'Serve dipped in sweet chilli sauce, hummus or salsa with vegetables and Lebanese bread.'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Chicken;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp)) || _class);
exports.default = Chicken;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipes/Chicken.js
// module id = 1229
// module chunks = 0